<template>
  <div class="h-auto bg-white w-full pt-6 pb-8 pl-6 pr-6">
    <div class="flex justify-start responsive-container pb-4">
      <div class="flex items-center justify-start gap-5">
        <div
          class=" flex items-center justify-start border border-gray py-2 rounded-100"
        >
          <icon
            :data="icons.IconSearch"
            height="26"
            width="26"
            class="w-5 h-5 mx-4"
            original
          />
          <input
            type="text"
            class="text-c16 responsive-input width"
            placeholder="Rechercher"
          >
        </div>
        <!-- <div
          class="border border-gray p-2 flex items-center rounded-100 gap-2 cursor-pointer responsive-filter"
        >
          <icon
            :data="icons.IconFiltre"
            height="26"
            width="26"
            class="w-5 h-5"
            original
          />
          Filtre
          <div class="bg-red text-white rounded-100 px-2">
            1
          </div>
        </div> -->
      </div>
    </div>
  
    <div class="">
      <div class="">
        <div class="w-full flex text-6b text-c14 2xl:text-c16 font-c4 text-left mb-6 diviser py-4 px-3 rounded-t-14">
          <div class="w-3/4">
            Nom
          </div>
  
          <div class="w-1/4 ml-20">
            Participants
          </div>
          <div class="w-1/6 Email responsive-large flex justify-center" />
        </div>
      </div>
    </div>
    <liste />
  </div>
</template>
  
  <script>
  import arrow from '../../../assets/icons/arrow.svg'
  import agenda from '../../../assets/icons/agenda.svg'
  import down from '../../../assets/icons/down.svg'
  import prev from '../../../assets/icons/prev.svg'
  import next from '../../../assets/icons/next.svg'
  import IconSearch from "../../../assets/icons/ic-search.svg";
  import IconFiltre from "../../../assets/icons/ic-filtre.svg";
  import liste from './liste.vue'
  
  export default {
    name: "Index",
    components: {
      liste
    },
  
    props: {
      search: {
        type: String,
        default: null
      },
      filtrage: {
        type: String,
        default: null
      }
    },
  
    data () {
      return {
        icons: {
          arrow,
          agenda,
          down,
          prev,
          next,
          IconSearch,
          IconFiltre
        },
        client: [],
        charge: true,
        page: 1,
        limite: 20,
        total: 0,
        totalPage: 0,
        devisPaginate: [],
        temoin: null,
        dataClient: []
      }
    },
    methods: {
    handlePartnerSelected(partner) {
      this.$emit('partnerSelected', partner); // On renvoie au parent (index.vue)
    }
  }
  
  }
  </script>
  
  <style lang="scss" scoped>
  .svg-icon{
    fill: transparent;
  }
  .filtr{
    background: rgba(242, 245, 249, 0.5);
    border: 0.5px solid #C4C4C4;
    box-sizing: border-box;
    border-radius: 5px;
    height: 36.39px;
  }
  .compFiltre{
    width: auto;
    min-width: 9.1%;
  }
  .diviser {
    background-color: #F6F8FA;
  }
  .width{
  width: 400px;
}
  </style>
  